module.exports = __webpack_public_path__ + "static/ces-00e4ec80b6113f307c1b173cc58a2c67.png";